import React from 'react'
import { useRouter } from 'next/router'

import { HeaderBar, HeaderBarLeftAction } from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/toolbox-helper'

import MateriVideo from 'app/PelatihanMandiriPage/pages/MateriVideo'
import PelatihanDetailShell from 'app/PelatihanMandiriPage/components/PelatihanDetailShell'
import { usePelatihanMandiriDesktopDetailView } from 'app/PelatihanMandiriPage/hooks/usePelatihanMandiriDesktopDetailView'
import { getModuleReturnUrl } from 'app/PelatihanMandiriPage/utils/detailNavigation'

import CloseIcon from 'assets/icons/close.svg'

const MateriVideoPage = () => {
  const isDesktopDetail = usePelatihanMandiriDesktopDetailView()
  const { query } = useRouter()

  if (isDesktopDetail) {
    return (
      <PelatihanDetailShell
        breadcrumbs={[
          { label: 'Pelatihan Mandiri', href: '/pelatihan-mandiri' },
          {
            label: String(query.topik_name ?? 'Topik'),
            href: `/pelatihan-mandiri/topik/${query.topik}`,
          },
          {
            label: String(query.modul_name ?? 'Modul'),
            href: getModuleReturnUrl(query, query.materi as string),
          },
          { label: String(query.materi_name ?? 'Materi'), href: null },
        ]}
        contentClassName="overflow-hidden rounded-lg border border-gray-20 bg-white"
      >
        <MateriVideo isDesktop />
      </PelatihanDetailShell>
    )
  }

  return <MateriVideo />
}

const PageHeader = () => {
  const router = useRouter()

  return (
    <HeaderBar fixed className="z-10">
      <HeaderBarLeftAction
        data-testid="back-button"
        icon={<CloseIcon className="stroke-current text-default" />}
        onClick={() => {
          if (router.query.return_view === 'topic') {
            router.replace(
              getModuleReturnUrl(router.query, router.query.materi as string)
            )
            return
          }

          historyUtils.backToApp(router.back)
        }}
      />
    </HeaderBar>
  )
}

MateriVideoPage.layoutOpts = {
  hasHeader: true,
  className: ' bg-gray-5 text-default',
  header: PageHeader,
  enableDesktopLayout: true,
}

export default MateriVideoPage
